/* unplugin-vue-components disabled */import script from "./LoginRegister.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginRegister.vue?vue&type=script&lang=ts&setup=true"

import "./LoginRegister.vue?vue&type=style&index=0&id=4dcea2ac&lang=scss&scoped=true"
import "./LoginRegister.vue?vue&type=style&index=1&id=4dcea2ac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dcea2ac"]])

export default __exports__